export default __webpack_public_path__ + "css/oneTimePassword.module.css";